import App from './App.vue';

export default {
  path: '/CDS_VF_JMAInfoList',
  name: 'CDS_VF_JMAInfoList',
  component: App,
  meta: {
    pageProperty: {
      title: '気象情報',
      controller: 'CDS_CTR_JMAInfoList',
    },
  },
};
